export const CHAT_BOOTSTRAP_ROUTE_PREFIX = 'api/chat'
